export const SvgPhoneConstructor = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M16.4187 1.49996V9.17435"
      stroke="#243CBB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5815 5.33716H20.2559"
      stroke="#243CBB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.7436 15.9765V18.6862C19.7446 18.9377 19.693 19.1867 19.592 19.4172C19.491 19.6477 19.3429 19.8546 19.1572 20.0247C18.9715 20.1947 18.7522 20.3242 18.5134 20.4048C18.2746 20.4854 18.0216 20.5153 17.7706 20.4927C14.9857 20.1907 12.3105 19.2409 9.96015 17.7197C7.77343 16.3329 5.91948 14.4827 4.52994 12.3003C3.00042 9.94389 2.04856 7.26107 1.75149 4.46915C1.72887 4.21938 1.75861 3.96764 1.83882 3.72996C1.91903 3.49229 2.04795 3.27389 2.21737 3.08866C2.38679 2.90343 2.59299 2.75544 2.82286 2.65411C3.05273 2.55278 3.30121 2.50032 3.55251 2.50009H6.26761C6.70683 2.49577 7.13264 2.651 7.46566 2.93683C7.79869 3.22267 8.01621 3.61961 8.07768 4.05366C8.19228 4.92084 8.40481 5.77229 8.71121 6.59177C8.83297 6.91507 8.85933 7.26642 8.78714 7.6042C8.71496 7.94198 8.54727 8.25203 8.30394 8.49761L7.15455 9.64473C8.44291 11.906 10.319 13.7784 12.5848 15.0642L13.7341 13.9171C13.9802 13.6742 14.2909 13.5069 14.6293 13.4348C14.9678 13.3628 15.3198 13.3891 15.6438 13.5106C16.4649 13.8164 17.318 14.0285 18.1869 14.1429C18.6266 14.2048 19.0281 14.4258 19.3151 14.7639C19.6021 15.1019 19.7546 15.5335 19.7436 15.9765Z"
      stroke="#243CBB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SvgTrashCan = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M3 6H5H21"
      stroke="#A6B3C9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
      stroke="#A6B3C9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="12"
      y1="11"
      x2="12"
      y2="17"
      stroke="#A6B3C9"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
